import styled from "styled-components";

export const LayoutContainer = styled.main`

max-width:  ${({ theme }) => theme.breakpoints.lg};
margin: 0px auto;
`;
